import React from "react";

const Car = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.462"
    height="13.867"
    viewBox="0 0 18.462 13.867"
  >
    <path
      id="Parking"
      d="M929.672,57.655a2.078,2.078,0,0,0-1.993,1.474l-.953,3.185-1.343-.455-.434,1.3,1.365.455-.434,1.474a.673.673,0,0,0-.022.195v5.547a.7.7,0,0,0,.693.693h2.08l.239-.693h10.617l.238.693h2.08a.7.7,0,0,0,.693-.693v-.585a.7.7,0,0,0,0-.109V65.282a.651.651,0,0,0-.022-.195l-.433-1.474,1.365-.455-.434-1.3-1.343.455-.953-3.185a2.078,2.078,0,0,0-1.994-1.474Zm0,1.387h9.014a.7.7,0,0,1,.672.5l.889,2.968H928.113L929,59.54A.7.7,0,0,1,929.672,59.042ZM927.7,63.9h12.958l.455,1.517v4.03H927.246v-4.03Zm1.278.693a1.04,1.04,0,1,0,1.04,1.04A1.04,1.04,0,0,0,928.979,64.589Zm10.4,0a1.04,1.04,0,1,0,1.04,1.04A1.04,1.04,0,0,0,939.38,64.589Zm-7.974,2.08-.866,2.08h1.5l.3-.693h3.683l.3.693h1.5l-.867-2.08Z"
      transform="translate(-924.949 -57.655)"
    />
  </svg>
);

export default Car;
